import React from 'react';

const ACTION_COLORS = {
  USER: '#3b82f6', PROJECT: '#8b5cf6', PAGE: '#f59e0b',
  PLANNING: '#10b981', ASSEMBLY: '#ec4899', RESOURCE: '#06b6d4',
};

const getActionColor = (action) => {
  const key = Object.keys(ACTION_COLORS).find(k => action?.includes(k));
  return key ? ACTION_COLORS[key] : 'var(--pico-muted-color)';
};

const formatRelativeTime = (timestamp) => {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString();
};

const ActivityLogItem = ({ log }) => {
  return (
    <div className="home-activity-entry">
      <span className="home-activity-dot" style={{ background: getActionColor(log.action) }} />
      <span className="home-activity-action" style={{ color: getActionColor(log.action) }}>
        {log.action?.replace(/_/g, ' ')}
      </span>
      <span className="home-activity-actor">{log.actorEmail || '—'}</span>
      {log.details?.projectName && <span className="home-activity-project">{log.details.projectName}</span>}
      <span className="home-activity-time">{formatRelativeTime(log.timestamp)}</span>
    </div>
  );
};

export default ActivityLogItem;
